/* DSL Battery-aware — suppress animations bij <20% battery */
(function(){
  if (!navigator.getBattery) return;
  navigator.getBattery().then(function(b){
    function update(){
      if (b.level < 0.2 && !b.charging) document.documentElement.classList.add("dsl-low-battery");
      else document.documentElement.classList.remove("dsl-low-battery");
    }
    update();
    b.addEventListener("levelchange", update);
    b.addEventListener("chargingchange", update);
  });
})();